import { WarehouseStockFilterOptions } from 'app/common/types/warehouse/stock'
import { BuildingId, OrgId } from 'app/common/types/id'
import type { Request } from '../../../index'

type ResultDto = {
  schools: Record<
    string,
    {
      id: number
      title: string
      buildings: Array<{ id: number; title: string }>
    }
  >
  is_central_warehouse: boolean
}

export const convertResult = (dto: ResultDto): WarehouseStockFilterOptions => {
  return {
    ...Object.values(dto.schools).reduce(
      (acc, school) => {
        acc.orgs.push({ id: String(school.id) as OrgId, title: school.title })
        acc.buildingsByOrgId[String(school.id) as OrgId] = school.buildings.map((b) => ({
          id: String(b.id) as BuildingId,
          title: b.title,
        }))
        return acc
      },
      {
        orgs: [] as Array<{ id: OrgId; title: string }>,
        buildingsByOrgId: {} as Record<OrgId, Array<{ id: BuildingId; title: string }>>,
      },
    ),
    isCentralWarehouse: dto.is_central_warehouse,
  }
}

export const GET_WAREHOUSE_FILTER_OPTIONS: Request<void, WarehouseStockFilterOptions, void> = [
  'food/warehouse/filter_options',
  'get',
  ['data'],
]
